<!--
 * @Author: your name
 * @Date: 2021-04-22 11:38:30
 * @LastEditTime: 2021-05-12 10:49:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/officialSeal/stamped/list.vue
-->
<template>
  <div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input clearable size="small" @keyup.enter.native="onSubmit" style="width:200px;" v-model="formInline.fileQueryString" placeholder="合同附件编号/名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable size="small" @keyup.enter.native="onSubmit" style="width:200px;" v-model="formInline.contractQueryString" placeholder="商务合同编号/名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable size="small" @keyup.enter.native="onSubmit" style="width:200px;" v-model="formInline.sealApplyUserName" placeholder="盖章申请人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable size="small" @keyup.enter.native="onSubmit" style="width:200px;" v-model="formInline.sealOperatorName" placeholder="盖章经办人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="onSubmit">搜 索</el-button>
          <el-badge style="margin:0 25px;" :value="multiSelectList.length" class="item">
            <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="openSealClick('',3)">批量盖章</el-button>
          </el-badge>
      </el-form-item>
    </el-form>
    <div>{{stampedType=='4'?'待':'已'}}{{stampedType=='6'?'作废':'盖章'}}合同总数：{{total}}条</div>
    <!-- 列表 -->
    <div style="padding:20px 0;" v-loading="loading">
      <el-table  size="small" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection"  width="55" align="center"></el-table-column>
        <el-table-column align="center" prop="code" label="合同附件编号"></el-table-column>
        <el-table-column align="center" prop="name" label="合同附件">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.fileList"></filePreview>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="address" label="盖章类型">
          <template slot-scope="scope">
            {{sealType[scope.row.sealType]}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="sealOperatorName" label="盖章经办人"></el-table-column>
        <el-table-column align="center" prop="contractName" label="所属商务合同"></el-table-column>
        <el-table-column v-if="stampedType == '6'" align="center" prop="voidUserName" label="作废人"></el-table-column>
        <el-table-column v-if="stampedType == '6'" align="center" prop="voidTime" label="作废时间"></el-table-column>
        <el-table-column v-if="stampedType == '4'" align="center" prop="sealApplyUserName" label="盖章申请人"></el-table-column>
        <el-table-column v-if="stampedType == '5'" align="center" prop="sealUserName" label="盖章人"></el-table-column>
        <el-table-column v-if="stampedType !== '6'" align="center" prop="sealApplyTime" label="盖章申请时间"></el-table-column>
        <el-table-column v-if="stampedType != '4'" align="center" prop="scannedCopyPath" label="合同扫描件">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.scannedCopyList"></filePreview>
            <!-- <div v-for="(item,index) in scope.row.scannedCopyList" :key="index">
              <a class="link chaochu" href="javascript:void(0);" @click="downloadFile(item.path, item.name)" :download="item.name">{{ item.name }}</a>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="detailsClick(scope.row.id)">查看</el-button>
            <template v-if="permissions.contract_stamped">
              <el-button v-if="stampedType == '4'" size="small" type="text" @click="openSealClick(scope.row.id,1)">盖章</el-button>
              <el-button v-if="stampedType == '5'" size="small" type="text" @click="openSealClick(scope.row.id,2)">评论</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="block" style="text-align:right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 详情 -->
    <contractDetails @close="closeClick" :dialogTableVisible="dialogTableVisible" :detailsId="detailsId"></contractDetails>
    <el-dialog :title="dialogTitle" width="70%" :visible.sync="dialogTableVisibleNew">
      <el-form  label-position="left" :model="remarkForm" ref="remarkForm" label-width="100px" class="demo-ruleform">
        <el-form-item label="说明：">
          <el-input type="textarea" v-model="remarkForm.remark" rows="4" show-word-limit placeholder="请输入评论" maxlength="100"></el-input>
        </el-form-item>
        <div v-if="remarkForm.type==1" style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="sealClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisibleNew = false">取 消</el-button>
        </div>
        <div v-if="remarkForm.type==2" style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="commentClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisibleNew = false">取 消</el-button>
        </div>
        <div v-if="remarkForm.type==3" style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="batchSealClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisibleNew = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { contractAttachedFileSealList,sealcContractAttachedFile,commentContractAttachedFile,batchSealContractAttachedFile } from "../api";
import contractDetails from "@/components/common/contractAttachmentDetails"
export default {
  props: ["stampedType"],
  components: {
    contractDetails,
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  data() {
    return {
      sealType:['不盖章','公章','合同章'],
      sealStatus:['不盖章','待申请盖章','盖章审核中','盖章审核不通过','待盖章','已盖章','已作废'],
      loading:false,
      dialogTableVisible:false,
      detailsId:"",
      total:0,
      formInline: {
        contractQueryString:"",
        fileQueryString:"",
        sealApplyUserName:"",
        sealOperatorName:"",
        sealStatus:this.stampedType,
        pageNum: 1,
        pageSize: 10,
      },
      dialogTableVisibleNew:false,
      remarkForm:{
        id:"" ,
        remark:"",
        type:""
      },
      dialogTitle:"",
      tableData: [],
      multiSelectList:[],
    };
  },
  watch: {
    stampedType(row) {
      this.formInline.sealStatus = row;
      this.getDataInit()
    },
  },
  mounted() {
    console.log('-----quanxian--------',this.permissions.contract_stamped)
    this.getDataInit()
  },
  methods: {
    //获取数据
    getDataInit(){
      this.loading = true;
      contractAttachedFileSealList(this.formInline).then(res=>{
        if(res.code === 1){
          this.tableData = res.data;
          this.total = res.total;
        }
        console.log('=======数据=======',res)
        this.loading = false;
      })
    },
    //搜索
    onSubmit(){
      this.getDataInit()
    },

    //选择
    handleSelectionChange(val){
      this.multiSelectList = val;
    },

    openSealClick(id,type){
      this.dialogTableVisibleNew = true ;
      this.remarkForm.id = id ;
      this.remarkForm.remark = "" ;
      this.remarkForm.type = type ;
      if(type==1){
        this.dialogTitle = '盖章' ;
      }else if(type==2){
        this.dialogTitle = '评论' ;
      }else if(type==3){
        this.dialogTitle = '批量盖章' ;
      }
      
    },

    //盖章
    sealClick(){
      this.$confirm('确认盖章吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sealcContractAttachedFile(this.remarkForm).then(res=>{
          if(res.code === 1){
            this.$message.success('盖章成功!');
            this.getDataInit()
            setTimeout(()=>{
              this.$router.go(0)
            },500)
          }
          console.log('=======盖章========',res)
        })
      }).catch(() => {
                  
      });
    },



    //批量盖章
    batchSealClick(){
      console.log(this.multiSelectList) ;
      var ids = []
      this.multiSelectList.forEach(element => {
        ids.push(element.id)
      });

      let obj = {};
      obj.ids = ids;
      obj.remark = this.remarkForm.remark ;

      this.$confirm('确认盖章吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        batchSealContractAttachedFile(obj).then(res=>{
          if(res.code === 1){
            this.$message.success('批量盖章成功!');
            this.getDataInit()
            setTimeout(()=>{
              this.$router.go(0)
            },500)
          }
          console.log('=======盖章========',res)
        })
      }).catch(() => {
                  
      });
    },

    //评论
    commentClick(){
      if(this.remarkForm.remark == ""){
        this.$message.console.error('请先填写评论内容!');
      } 

      this.$confirm('确认吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        commentContractAttachedFile(this.remarkForm).then(res=>{
          if(res.code === 1){
            this.$message.success('评论成功!');
            this.getDataInit()
            setTimeout(()=>{
              this.$router.go(0)
            },500)
          }
          console.log('=======评论========',res)
        })
      }).catch(() => {
                  
      });
    },


    closeClick(){
      this.dialogTableVisible = false;
    },
    //详情
    detailsClick(id){
      this.detailsId = id;
      this.dialogTableVisible = true;
    },
    handleSizeChange(val){
      this.formInline.pageSize = val;
      this.getDataInit()
    },
    handleCurrentChange(val){
      this.formInline.pageNum = val;
      this.getDataInit()
    },
  },
};
</script>
<style scoped>
.chaochu{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.header_dialog{
    display: flex;
    justify-content: space-between;
}
.header_dialog div{
    padding-bottom:10px;
    font-size: 15px;
}
.paddingBtm div{
    padding-bottom:10px;
    font-size: 15px;
}
</style>